import { JobListDataProps } from "./Section";

export const JobData: Record<string, JobListDataProps> = {
  "game-product-manager": {
    title: "GAME PRODUCT MANAGER",
    subTitle: "Management | Full-Time | On-Site",
    cities: "Hanoi, Danang, Ho Chi Minh, Milan",
    items: [
      {
        upperTitle: "Job description",
        description:
          "As the Game Product Manager, you will drive the roadmap and product vision of the game in collaboration with the rest of the game’s leadership team. You will work closely with the design and creative team to ensure that the product vision is followed and executed to specification. In this key leadership role, you will work closely with other product leaders, our Art Director, Executive Producer and Technical Director.",
        listTitle: "As a Game Product Manager, you will be required to:",
        list: [
          "Engage with the Product Leadership Team(s) comprising the Producer, Designer and the External Partner Leadership Team to arrive at the right Product Strategy that delivers on the Creative Vision and Business Goals of the franchise.",
          "Be the day-to-day vision holder of the product at Gear, and help align efforts across design, engineering, production, and the rest of the team to achieve that vision.",
          "Drive business forecasting considering Product and Industry Trends, Tech and Design realities and other Strategic Insights",
          "Strategize Player Lifecycle Management - Messaging, Segmentation, Personalization, Game Events etc.",
          "Regularly identify, present and report to leadership and stakeholders on Product Health, Opportunities and Risks ",
        ],
      },
      {
        upperTitle: "Requirements",
        list: [
          "5+ years of Product management experience in Game development",
          "Strong passion for Mobile gaming and understanding of Mobile + Freemium / Free-to-Play Business model.",
          "Fluency with metrics-driven decision-making combined with a sense of Design and Aesthetics",
          "Earning the respect of the Cross-Functional Team through authentic insights on Game Design, Business Fundamentals and Analytical Methodologies",
          "A ‘Creative Product Development’ mindset – Iterative nature of work, Comfort with complexity and change, Multi-Disciplinary approach to problem-solving",
          "Fluent in English",
          "Work at the Milan office (Candidates with the right to work in Europe and open to relocating to Milan are welcome)",
        ],

      },
      {
        upperTitle: "Advantages",
        list: [
          "Have experience with the development and live operations of top-grossing mobile games",
          "Experience developing feature roadmaps and/or content calendars. Experience with backlog management, priority setting, and user modeling",
          "Experience A/B testing design assumptions to maximize KPIs of a feature",
          "Experience working with remote teams and partners",
          "Experience working & managing games/products based on Western IP's",
        ],

      },
      {
        upperTitle: "Rewards",
        description:
          "At Gear Inc., we value talent and strive to create an engaging and caring working environment as we appreciate our employee's hard work and dedication. We understand that mental health is as important as financial well-being, thus we offer an attractive compensation and benefit package as well as so many fun and exciting activities to engage employees, boost up their topmost creativity and productivity at work, including but not limited to:",

        list: [
          "Competitive salary and attractive performance bonus, profit sharing;",
          "Welfare voucher, lunch tickets;",
          "Mental health care services;,",
          "Relocation package and support when moving geographic locations to join Gear Inc;",
          "Flexible working time and hybrid work, optional standing desks, modern hardware, no dress code, pantry area with complimentary drinks, snacks and fruit;",
          "Many exciting internal activities;",
        ],
        conclude: [
          "Subject to the work type and location, the benefit package offered might be different.",
          "We are a fun and international working environment where work is play. If you want to be a part of our team, apply now!",
        ],
      },
      {
        upperTitle: "About us",
        description:
          "Gear Inc. is an operated Game Development Studio with offices expanding globally.",
        conclude: [
          "We hire exceptionally creative and talented people from all over the globe that bring experience and international standards to the table, but thats just the start! Commitment to our people is our real strength and the key to our success.",
        ],
      },
      {
        upperTitle: "Our offices in Vietnam",
        list: [
          "125D Minh Khai, Hai Ba Trung, Hanoi",
          "52 Nguyen Van Linh, Hai Chau, Danang",
          "561A Dien Bien Phu, Binh Thanh, Ho Chi Minh",
          "In Italy: Via Borghetto N.3 – 20122 Milano, P.I. 12774480961",
        ],
        conclude: [
          "For more information, please visit our:",
          "Website: https://www.gearinc.com/gaming/",
          "Facebook fan page: https://www.facebook.com/GearIncTeam/",
        ],
      },
    ],
  },
  "mid-senior-game-designer": {
    title: "MID/SENIOR GAME DESIGNER",
    subTitle: "Design | Full-Time | On-Site",
    cities: "Hanoi, Danang, Ho Chi Minh, Milan",
    items: [
      {
        upperTitle: "Job description",
        description:
          "As the Game Product Manager, you will drive the roadmap and product vision of the game in collaboration with the rest of the game’s leadership team. You will work closely with the design and creative team to ensure that the product vision is followed and executed to specification. In this key leadership role, you will work closely with other product leaders, our Art Director, Executive Producer and Technical Director.",
        listTitle: "As a Game Product Manager, you will be required to:",
        list: [
          "Engage with the Product Leadership Team(s) comprising the Producer, Designer and the External Partner Leadership Team to arrive at the right Product Strategy that delivers on the Creative Vision and Business Goals of the franchise.",
          "Be the day-to-day vision holder of the product at Gear, and help align efforts across design, engineering, production, and the rest of the team to achieve that vision.",
          "Drive business forecasting considering Product and Industry Trends, Tech and Design realities and other Strategic Insights",
          "Strategize Player Lifecycle Management - Messaging, Segmentation, Personalization, Game Events etc.",
          "Regularly identify, present and report to leadership and stakeholders on Product Health, Opportunities and Risks ",
        ],

      },
      {
        upperTitle: "Requirements",
        list: [
          "5+ years of Product management experience in Game development",
          "Strong passion for Mobile gaming and understanding of Mobile + Freemium / Free-to-Play Business model.",
          "Fluency with metrics-driven decision-making combined with a sense of Design and Aesthetics",
          "Earning the respect of the Cross-Functional Team through authentic insights on Game Design, Business Fundamentals and Analytical Methodologies",
          "A ‘Creative Product Development’ mindset – Iterative nature of work, Comfort with complexity and change, Multi-Disciplinary approach to problem-solving",
          "Fluent in English",
          "Work at the Milan office (Candidates with the right to work in Europe and open to relocating to Milan are welcome)",
        ],

      },
      {
        upperTitle: "Advantages",
        list: [
          "Have experience with the development and live operations of top-grossing mobile games",
          "Experience developing feature roadmaps and/or content calendars. Experience with backlog management, priority setting, and user modeling",
          "Experience A/B testing design assumptions to maximize KPIs of a feature",
          "Experience working with remote teams and partners",
          "Experience working & managing games/products based on Western IP's",
        ],

      },
      {
        upperTitle: "Rewards",
        description:
          "At Gear Inc., we value talent and strive to create an engaging and caring working environment as we appreciate our employee's hard work and dedication. We understand that mental health is as important as financial well-being, thus we offer an attractive compensation and benefit package as well as so many fun and exciting activities to engage employees, boost up their topmost creativity and productivity at work, including but not limited to:",

        list: [
          "Competitive salary and attractive performance bonus, profit sharing;",
          "Welfare voucher, lunch tickets;",
          "Mental health care services;,",
          "Relocation package and support when moving geographic locations to join Gear Inc;",
          "Flexible working time and hybrid work, optional standing desks, modern hardware, no dress code, pantry area with complimentary drinks, snacks and fruit;",
          "Many exciting internal activities;",
        ],
        conclude: [
          "Subject to the work type and location, the benefit package offered might be different.",
          "We are a fun and international working environment where work is play. If you want to be a part of our team, apply now!",
        ],
      },
      {
        upperTitle: "About us",
        description:
          "Gear Inc. is an operated Game Development Studio with offices expanding globally.",
        conclude: [
          "We hire exceptionally creative and talented people from all over the globe that bring experience and international standards to the table, but thats just the start! Commitment to our people is our real strength and the key to our success.",
        ],
      },
      {
        upperTitle: "Our offices in Vietnam",
        list: [
          "125D Minh Khai, Hai Ba Trung, Hanoi",
          "52 Nguyen Van Linh, Hai Chau, Danang",
          "561A Dien Bien Phu, Binh Thanh, Ho Chi Minh",
          "In Italy: Via Borghetto N.3 – 20122 Milano, P.I. 12774480961",
        ],
        conclude: [
          "For more information, please visit our:",
          "Website: https://www.gearinc.com/gaming/",
          "Facebook fan page: https://www.facebook.com/GearIncTeam/",
        ],
      },
    ],
  },
};
